var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-row",
    [
      _c(
        "b-col",
        { attrs: { cols: "12", lg: "8" } },
        [
          _c(
            "b-row",
            [
              _c(
                "b-col",
                { attrs: { cols: "8 mb-3" } },
                [
                  _c("b-skeleton", {
                    attrs: {
                      type: "input",
                      animation: "fade",
                      width: "80%",
                      height: "0.5rem",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-col",
                { attrs: { cols: "4 mb-3" } },
                [
                  _c("b-skeleton", {
                    attrs: {
                      type: "input",
                      animation: "fade",
                      width: "80%",
                      height: "0.5rem",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-col",
                { attrs: { cols: "4 mb-3" } },
                [
                  _c("b-skeleton", {
                    attrs: {
                      type: "input",
                      animation: "fade",
                      width: "80%",
                      height: "0.5rem",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-col",
                { attrs: { cols: "8 mb-3" } },
                [
                  _c("b-skeleton", {
                    attrs: {
                      type: "input",
                      animation: "fade",
                      width: "80%",
                      height: "0.5rem",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-col",
                { attrs: { cols: "12 mb-3" } },
                [
                  _c("b-skeleton", {
                    attrs: {
                      type: "input",
                      animation: "fade",
                      width: "80%",
                      height: "0.5rem",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-col",
                { attrs: { cols: "4 mb-3" } },
                [
                  _c("b-skeleton", {
                    attrs: {
                      type: "input",
                      animation: "fade",
                      width: "80%",
                      height: "0.5rem",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-col",
                { attrs: { cols: "4 mb-3" } },
                [
                  _c("b-skeleton", {
                    attrs: {
                      type: "input",
                      animation: "fade",
                      width: "80%",
                      height: "0.5rem",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-col",
                { attrs: { cols: "4 mb-3" } },
                [
                  _c("b-skeleton", {
                    attrs: {
                      type: "input",
                      animation: "fade",
                      width: "80%",
                      height: "0.5rem",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }